


































































































import Vue, { VNode } from 'vue';

import Player from '@/structs/player.class';
import EventsType from '@/structs/events';
import tableMixin from '@/mixins/table';

import { debounce, memoize } from 'lodash';

function memoizeDebounce(func: (...args: any) => any, wait=0, options={}) {
  const mem = memoize((param) => debounce(func, wait, options));
  return (param: any) => mem(param)(param);
}

const ResetBtn = Vue.extend({
  props: {
    onClick: Function,
  },
  render: function (createElement): VNode {
    return createElement('b-button', {
      props: {
        'icon-left': 'redo',
        type: 'is-primary',
      },
      on: {
        click: this.onClick
      },
    })
  },
});

const RemovePlayerBtn = Vue.extend({
  props: {
    onClick: Function,
  },
  render: function (createElement): VNode {
    return createElement('b-button', {
      props: {
        'icon-left': 'trash-alt',
        type: 'is-danger',
      },
      on: {
        click: this.onClick
      },
    })
  },
});

export default tableMixin.extend({
  name: 'PlayerTable',
  components: { ResetBtn, RemovePlayerBtn },
  props: {
    step: Number,
    currentPlayer: Player,
  },
  computed: {
    selected: {
      get(): Player {
        return this.currentPlayer;
      },
      set(player: Player) {
        this.$emit('sync', 'currentPlayer', player);
      },
    },
  },
  created() {
    (this as any).deboucedAfterPlay = memoizeDebounce(
      this.$emit.bind(this, 'after-play'), 1500);
  },
  methods: {
    toggle(player: Player) {
      (this.$refs.table as any).toggleDetails(player);
    },
    removePlayer(player: Player): void {
      const index = this.players.findIndex(p => p === player);
      this.players.splice(index, 1);

      this.sendRemovePlayerEvents(player);

      this.$buefy.toast.open({
        message: `${player.name} has been removed from the game.`,
        type: 'is-info'
      });
    },
    sendRemovePlayerEvents(player: Player): void {
      this.$emit('sync', 'players', this.players);
      this.emitLogEvent({
        type: EventsType.PLAYER_REMOVED,
        data: { player: player.name }
      });
    },
    resetPlayerScore(player: Player): void {
      player.resetScore();
      this.emitLogEvent({
        type: EventsType.SCORE_RESET,
        data: { player: player.name }
      });
    },
    addPoints(player: Player, points: number): void {
      player.addPoints(points);

      // method not detected as created in created()
      (this as any).deboucedAfterPlay(player);

      this.emitLogEvent({
        type: EventsType.POINTS,
        data: { player: player.name, points: points }
      });
    },
  },
});
